import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    messages: [],
    contacts: [],
}

const mutations = {
    message_list(state, messages){
        Vue.set(state, 'messages', messages);
        Vue.set(state, 'messages', [...messages]);
    },

    addMessage(state, messages){
        state.messages.push(messages)
    },

    contacts_list(state, contacts){
        Vue.set(state, 'contacts', contacts);
        Vue.set(state, 'contacts', [...contacts]);
    },

    nothing(){},

    SEND_CHAT_MESSAGE(state, payload) {
        state.chats[Object.keys(state.chats).find(key => key == payload.id-1)].msg.push(payload.msg)
    },
}

const actions = {
    getSameOrders({ commit, dispatch }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/orders/${payload.type}/${payload.userId}`, method: 'GET' })
            .then(res => {
                commit("contacts_list" , res.data.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    getMessages({ commit, dispatch }, orderId){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/messages/${orderId}`, method: 'GET' })
            .then(res => {
                commit("message_list" , res.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    sendMessage({ commit, dispatch }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/messages`, data: payload, method: 'POST' })
            .then(res => {
                // commit("addMessage" , res.data)
                commit("nothing")
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    uploadFile({ commit, dispatch }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/messages`, data: payload, method: 'POST', headers: {
                'Authorization' : `Bearer ${localStorage.token}`,
                'Content-Type': 'multipart/form-data'
            } })
            .then(res => {
                // commit("addMessage" , res.data)
                commit("nothing")
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },
}

const getters = {
    conversation: (state) => (id) => {
        return state.chats.find(chat => chat.id === id)
    }
}

export default({
    state,
    mutations,
    actions,
    getters
})
